/**
 * Socket.IO event names — keep in sync with services/bff-service/src/realtime/realtimeEvents.js
 */
export const ADMIN_REALTIME_EVENTS = {
  FLEET_TELEMETRY: 'fleet:telemetry',
  WATCHTOWER_TRIP_UPDATE: 'watchtower:trip_update',
  WATCHTOWER_ALERT: 'watchtower:alert',
  WATCHTOWER_EMERGENCY: 'watchtower:emergency',
  DASHBOARD_SYNC: 'dashboard:sync',
  NEW_BOOKING: 'NEW_BOOKING',
  BID_SUBMITTED: 'BID_SUBMITTED',
  BOOKING_ASSIGNED: 'BOOKING_ASSIGNED',
  BOOKING_EXPIRED: 'BOOKING_EXPIRED',
  DRIVER_ASSIGNED: 'DRIVER_ASSIGNED',
  DRIVER_ARRIVED: 'DRIVER_ARRIVED',
  TRIP_STARTED: 'TRIP_STARTED',
  TRIP_COMPLETED: 'TRIP_COMPLETED',
  BOOKING_CANCELLED: 'BOOKING_CANCELLED',
  CLIENT_SUBSCRIBE: 'admin:subscribe',
};
